import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-display-apikey-dialog',
  templateUrl: './display-apikey-dialog.component.html',
  styleUrls: ['./display-apikey-dialog.component.css']
})
export class DisplayApikeyDialogComponent implements OnInit {
  apiKeyPlain: string;

  constructor(
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DisplayApikeyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

  async copyKey() {
    if ( this.copyTextToClipboard(this.data.apiKeyPlain) ) {
      this.snackBar.open('API Key was copied to clipboard');
    } else {
      this.snackBar.open('Error copying API Key to clipboard');
    }
  }

  copyTextToClipboard(text) {
    const txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = text;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
      if (successful) {
        return true;
      }
    } catch (err) {
      console.log('Oops, unable to copy');
    } finally {
      document.body.removeChild(txtArea);
    }
    return false;
  }

}
